import './styles/Painel.css'
const Devices = ({ device, setDevice }) => {
    const onClickDevice = (dispositivo) => {
        //console.log("dispositivo escolhido = ", dispositivo);
        setDevice(dispositivo);
    }
    return (  
        <div className="devices">
            <h2>Meus Dispositivos</h2>
            <div className="devices-conteiner">
                {device.map((dispositivo) => (
                    <div className="devices-preview" key={dispositivo.deviceID}>
                        <h3>{ dispositivo.deviceName }</h3>
                        <h3>Criado em: { dispositivo.criadoEm }</h3>
                        <h3>Ultimo Login: { dispositivo.ultimoLogin }</h3>
                        <button onClick={() => onClickDevice(dispositivo)}>Abrir</button>
                    </div>
                ))}
            </div>            
        </div>
    );
}
 
export default Devices;